<template>
  <div class="shop-main">
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="counter">
      <div class="card" v-if="vCardList.length > 0">
        <div class="card-show" v-for="item in vCardList" :key="item.id">
          <div class="card-img">
            <img src="../../assets/icon_kabao_selected@2x.png" />
          </div>
          <div class="card-text">
            <div class="card-text-left">
              <div class="card-master">
                {{ item.name }}
                <!-- <span v-if="item.isMaster">主卡</span> -->
                <span v-if="item.shopId == shopId">{{ $t('currentShopTip') }}</span>
              </div>
              <!-- <div class="cardno">{{ item.cardNo }}</div> -->
            </div>
            <div class="card-div-right">
              <div>￥{{ (item.accountBalance / 100 || 0).toFixed(2) }}</div>
            </div>
          </div>
          <div class="card-btn" @click="handleCheckShopInfo(item)">{{ $t('shopView') }}</div>
        </div>
      </div>
      <div class="nullData" v-else>{{ $t('noData') }}</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  data() {
    return {
      vCardList: [],
      customerId: "",
      shopId: localStorage.getItem("shopId"),
    };
  },
  mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    this.getCardList();
  },
  methods: {
    //获取卡列表
    getCardList() {
      this.$authAjax
        .get(`/api/wxapp/paycard/list/${this.customerId}`)
        .then((res) => {
          let resData = res.data;
          console.log(resData);
          if (resData.code === 200) {
            this.vCardList = resData.data[0].payCards;
          } else {
            this.$toast(resData.message);
          }
        });
    },
    // 查看
    handleCheckShopInfo(item) {
      this.$router.push({
        path: '/card/detail',
        query: {
          cardName: item.name,
          isMaster: item.isMaster ? 1 : 0,
          customerId: item.customerId,
          id: item.id,
          shopId: item.shopId
        }
      })
    },
    async handleChangeShop2(item) {
      await Dialog.confirm({
        title: "商户切换",
        message: "切换商户后应用将会重新加载，请确认",
      });
      const res = await this.$authAjax.post("/api/wxapp/generateToken2", {
        shopId: item.shopId,
      });

      const resData = res.data.data;

      const accessToken = resData.accessToken;
      localStorage.setItem("token", accessToken);
      localStorage.setItem("shopId", item.shopId);

      // 刷新
      // 跳转路由
      const url = `${location.origin}/${location.pathname}/#/?code=${resData.code}`;

      window.location.replace(url);
    },
    //切换
    async handleChangeShop(item) {
      // 提示
      await Dialog.confirm({
        title: "商户切换",
        message: "切换商户后应用将会重新加载，请确认",
      });
      item.cardId = item.id;
      item.isMaster = true;
      const res = await this.$authAjax.post("/api/wxapp/paycard/update", item);
      console.log("res", res);
      const resData = res.data.data;

      console.log("resData", resData);
      sessionStorage.removeItem("branchId");
      sessionStorage.removeItem("adress");

      await Dialog.alert({
        message: "切换成功",
        showCancelButton: false,
        closeOnPopstate: false,
        closeOnClickOverlay: false,
      });

      const url = `${location.origin}${location.pathname}/#/?code=${resData}`;

      window.location.replace(url);

      // .then(async (res) => {
      //   let resData = res.data;
      //   if (resData.code == 200) {
      //     this.$toast("切换成功，正在退出");
      //     sessionStorage.removeItem('branchId');
      //     // await this.$logina.post("/api/wxapp/h5Logout");
      // window.$auth.clearUserToken()
      //     setTimeout(() => {
      //       window.location.href = localStorage.getItem("homeUrl");
      //     }, 1000);
      //   } else {
      //     this.$toast(resData.message);
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-main {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  overflow: auto;
  padding: 12px;
  box-sizing: border-box;
  .counter {
    // margin-top: 45px;
    .nullData {
      font-size: 20px;
      text-align: center;
      color: red;
      margin-top: 100px;
    }
    .card-show {
      width: 347px;
      height: 120px;
      background: url("../../assets/shopCard-bg.png") no-repeat;
      background-size: 100% 100%;
      margin: 18px auto;
      position: relative;
      display: flex;
      // align-items: center;
      padding: 12px;
      box-sizing: border-box;
      .card-img {
        height: 40px;
        width: 40px;
        background: #ffffff;
        border-radius: 50%;
        text-align: center;
        img {
          height: 30px;
          width: 30px;
          margin-top: 5px;
        }
      }
      .card-text {
        width: 90%;
        display: flex;
        justify-content: space-between;
        // align-items: center;
        margin-left: 6px;
        margin-top: 5px;
        .card-master {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          line-height: 14px;
          span {
            width: 26px;
            height: 12px;
            background: #07c160;
            border-radius: 6px 6px 6px 6px;
            font-size: 8px;
            font-weight: 300;
            color: #ffffff;
            line-height: 12px;
            text-align: center;
          }
        }
        .cardno {
          font-size: 12px;
          font-weight: 300;
          color: #ffffff;
          line-height: 24px;
        }
        .card-div-right {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          line-height: 14px;
        }
      }
      .card-btn {
        width: 347px;
        height: 26px;
        background: rgba(255, 255, 255, 0.29);
        border-radius: 0px 0px 8px 8px;
        position: absolute;
        left: 0;
        bottom: 0;
        text-align: center;
        line-height: 26px;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
}
</style>
